import _ from 'lodash'

import { reconcileEventAccess } from '@/shared/lib/auth/access'
import { getAuthActions } from '@/shared/lib/auth/actions'
import { recoverAuthenticatedApiError } from '@/shared/lib/auth/api-recovery'
import { getCurrentTenantSlug } from '@/shared/lib/tenant'

import type { AxiosInstance } from 'axios'
import { session } from '@/shared/services/session/instance'

function isUserDigitalProductRequest(error: unknown) {
  const url = _.get(error, 'config.url', '')
  return (
    typeof url === 'string' &&
    url.includes('/user/digital_products/') &&
    !url.includes('/public/')
  )
}

function resolveAccessContext(session: { accessToken?: string | null } | null) {
  return {
    accessToken: session?.accessToken,
    tenantSlug: getCurrentTenantSlug()
  }
}

export function attachRecoveryInterceptor(client: AxiosInstance): void {
  client.interceptors.response.use(
    response => response,
    async error => {
      try {
        if (typeof window !== 'undefined') {
          const status = _.get(error, 'response.status')
          const bodyStatus = _.get(error, 'response.data.status_code')
          const recovered = await recoverAuthenticatedApiError({
            status,
            bodyStatus,
            error,
            isUserDigitalProductRequest: isUserDigitalProductRequest(error),
            getAccessContext: async () =>
              // O token vem do store em memória: leitura síncrona, sem a
              // chamada que o `getCachedSession` precisava deduplicar.
              resolveAccessContext({ accessToken: session.tokenStore.get() }),
            reconcileAccess: reconcileEventAccess,
            retryRequest: config => client(config),
            handleNoTicket: slug => getAuthActions().handleNoTicket(slug),
            signOut: () => getAuthActions().signOut()
          })

          if (typeof recovered !== 'undefined') {
            if (recovered === null) return Promise.reject(error)
            return recovered
          }
        }
      } catch {}

      return Promise.reject(error)
    }
  )
}
